const SELECTOR = '[id$="__ugc_grid"] img';

function init() {
  const imgs = () => [...document.querySelectorAll(SELECTOR)];
  if (!imgs().length) return;

  const dialog = document.createElement('dialog');
  dialog.className = 'ugc-lightbox';
  dialog.innerHTML =
    '<button type="button" class="ugc-lightbox__btn ugc-lightbox__close" aria-label="Close">&times;</button>' +
    '<button type="button" class="ugc-lightbox__btn ugc-lightbox__prev" aria-label="Previous">&#8249;</button>' +
    '<img class="ugc-lightbox__img" alt="">' +
    '<button type="button" class="ugc-lightbox__btn ugc-lightbox__next" aria-label="Next">&#8250;</button>';
  document.body.appendChild(dialog);

  const big = dialog.querySelector('.ugc-lightbox__img');
  let index = 0;

  const show = (i) => {
    const list = imgs();
    index = (i + list.length) % list.length;
    const el = list[index];
    const src = el.currentSrc || el.src;
    big.src = src.replace(/width=\d+/, 'width=1600');
    big.alt = el.alt;
  };

  document.addEventListener('click', (e) => {
    const el = e.target.closest(SELECTOR);
    if (!el) return;
    e.preventDefault();
    show(imgs().indexOf(el));
    dialog.showModal();
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog || e.target.closest('.ugc-lightbox__close')) dialog.close();
    else if (e.target.closest('.ugc-lightbox__prev')) show(index - 1);
    else if (e.target.closest('.ugc-lightbox__next')) show(index + 1);
  });

  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') show(index - 1);
    if (e.key === 'ArrowRight') show(index + 1);
  });

  let startX = 0;
  dialog.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
  dialog.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
  });
}

init();
